import { combineReducers } from 'redux';

import { userReducer } from './userReducer';
import { projectsReducer } from './projectsReducer';
import { menuReducer } from './menuReducer';
import { environmentsReducer } from './environmentsReducer';
import { activitiesReducer, activitiesByTypeReducer } from './activitiesReducer';
import { packagesReducer } from './packagesReducer';
import { applicationReducer } from './applicationReducer';
import { dashboardReducer } from './dashboardReducer';
import { databasesReducer } from './databasesReducer';
import { commandsReducer } from './commandsReducer';
import { projectReducer } from './projectReducer';
import { enumsReducer } from './enumsReducer';
import { securityReducer } from './securityReducer';
import { scriptsReducer } from './scriptsReducer';
import { jobsReducer } from './jobsReducer';
import { filesReducer } from './filesReducer';
import { logsReducer } from './logsReducer';
import { reportsReducer } from './reportsReducer';
import { cmsReducer } from './cmsReducer';
import { shepherdToursReducer } from './shepherdToursReducer';
import { policyEngineReducer } from './policyEngineReducer';
import { tagTypesReducer } from './tagTypesReducer';
import { tagsReducer } from './tagsReducer';
import { licenseReducer } from './licenseReducer';
import { hooksReducer } from './hooksReducer';
import { backupsReducer } from './backupsReducer';
import { adminReducer } from '@src/store/reducers/adminReducer';
import { vaultReducer } from '@src/store/reducers/vaultReducer';
import { chatbotReducer } from '@src/store/reducers/chatbotReducer';

export const getReducers = () => combineReducers({
    security: securityReducer,
    user: userReducer.reduce, // userReducer.wrapperReduce,
    projects: projectsReducer,
    menus: menuReducer,
    environments: environmentsReducer,
    activities: activitiesReducer,
    activitiesByType: activitiesByTypeReducer,
    packageManager: packagesReducer,
    application: applicationReducer,
    dashboard: dashboardReducer,
    schemas: databasesReducer,
    automation: commandsReducer,
    project: projectReducer,
    enums: enumsReducer,
    scripts : scriptsReducer,
    jobs : jobsReducer,
    files: filesReducer,
    logs: logsReducer,
    reports: reportsReducer,
    cmss: cmsReducer,
    policyEngine: policyEngineReducer,
    shepherd: shepherdToursReducer,
    tagTypes: tagTypesReducer,
    tags: tagsReducer,
    license: licenseReducer,
    hooks: hooksReducer,
    backups: backupsReducer,
    admin: adminReducer,
    vaults: vaultReducer,
    chatbots: chatbotReducer
});



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/index.ts